import UI from '../../components/ExcerciseTypes/Design/UserInterface';
import Circle_Write from '../../components/ExcerciseTypes/Circle_Write';
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import DrawColor from '../../components/ExcerciseTypes/DrawColor';


const json = {
  1: {
    unit: 'Unit 9',
    id: 'WB3-U9-P64-E1',
    audio: '',
    video: '',
    component: UI,
    titleImage: '',
    question: [
    ],
    questionImage: [
      [
        { url: 'img/FriendsPlus/Page64/2.jpg' },
      ]
    ]
  },
  2: { // Exercise num
    unit: 'Unit 9',
    id: 'WB3-U9-P64-E2',
    audio: '',
    video: '',
    component: DrawColor,
    exerciseKey: 'img/FriendsPlus/Page64/E2/Key/answerKey.png',
    titleQuestion: [{ num: '2', title: 'Read again. Circle three clothes words. Underline one toy.', color: "#5B5A5D" }],
    question: {
      Write: {
        underlineStyle: {},
        inputStyle: {},
        answers: [],
        initialValue: [],
      },
      Circle: {
        listStyle: {
          normal: {},
          circle: { padding: 3, border: 'solid 2px', borderRadius: '50%', borderColor: 'gray' },
          underline: { borderBottom: '2px solid gray' },
          // square: { padding: 3, border: 'solid 2px', borderColor: '#4285F4' },
        },
        // limitSelect: 1,
        listWords: [
          'I’m at the station',//1
          'Where is my friend?',//1
          'At the front of the train?',
          'Or is she at the end?',

          'Where is Lucy?',
          'Is she wearing a skirt?',
          'Is she wearing her jeans?',
          'Or wearing a shirt?',

          'Here is my friend.',
          'She has a toy cow.',
          'I say, “ Hello, Lucy,”',
          'And we’re both happy now.',
        ],
        answers: { '9-8': 'underline', '5-8': 'circle', '6-8': 'circle', '7-6': 'circle' },
        initialValue: {},
      },
      Layout: `
      <div style='width: 1000px;position:relative'>
        <img src="img/FriendsPlus/Page64/E2/1.jpg" style="width: 100%" />
        <div style='position: absolute;top: 40px;left:65% ; text-align: center;'>
          <div style='letter-spacing: 0px;'>
              <h1> <b> Where is my friend? </b></h1>
              <div> <input id='0' type='Circle' />  </div>
              <div> <input id='1' type='Circle' />  </div>
              <div> <input id='2' type='Circle' />  </div>
              <div> <input id='3' type='Circle' />  </div>
              <br>
              <div> <input id='4' type='Circle' />  </div>
              <div> <input id='5' type='Circle' />  </div>
              <div> <input id='6' type='Circle' />  </div>
              <div> <input id='7' type='Circle' />  </div>
              <br>
              <div> <input id='8' type='Circle' />  </div>
              <div> <input id='9' type='Circle' />  </div>
              <div> <input id='10' type='Circle' />  </div>
              <div> <input id='11' type='Circle' />  </div>
          </div>
        </div>
    
     </div>
      `,
    },
  },

  3: {
    // Exercise num
    unit: 'Unit 9',
    id: 'WB3-U9-P64-E3',
    audio: "",
    video: "",
    component: T6,
    exerciseKey: "img/FriendsPlus/Page64/E3/Key/answerKey.png",
    inputSize: 100,
    titleImage: "",
    titleQuestion: [{ color: '#3F3478', num: '3', title: "Read again. Write  <b style=''>yes</b> or <b>no.</b>  " }],
    questionImage: [],
    questions: [
      {
        title: `
          <div >
               <img src="img/FriendsPlus/Page64/E3/1.jpg" style="width: 80%" />
              <div><b>1</b> The girl is at the station. <u style='color: gray;'><i>yes</i></u></div>
              <div><b>2</b> She can’t find her mom. #</div>
              <div><b>3</b> Her friend’s name is Lucy. # </div>
              <div><b>4</b> Lucy is on the bus. # </div>
              <div><b>5</b> Lucy has a toy cow. # </div>
              <div><b>6</b> Lucy and her friend are angry. # </div>
          </div>
        `,
        answer: ["No", "Yes", "No", "Yes", "No"],
      },
    ],
  },



}
export default json;